export default {
    zhHans: {
        $vuetify: {
            badge: '徽章',
            close: '关闭',
            dataIterator: {
                noResultsText: '没有符合条件的结果',
                loadingText: '加载中……',
            },
            dataTable: {
                itemsPerPageText: '每页数目：',
                ariaLabel: {
                    sortDescending: '：降序排列。点击以移除排序。',
                    sortAscending: '：升序排列。点击以降序排列。',
                    sortNone: '：未排序。点击以升序排列。',
                },
                sortBy: '排序方式',
            },
            dataFooter: {
                itemsPerPageText: '每页数目：',
                itemsPerPageAll: '全部',
                nextPage: '下一页',
                prevPage: '上一页',
                firstPage: '首页',
                lastPage: '尾页',
                pageText: '{0}-{1} 共 {2}',
            },
            datePicker: {
                itemsSelected: '已选择 {0}',
            },
            noDataText: '没有数据',
            carousel: {
                prev: '上一张',
                next: '下一张',
                ariaLabel: {
                    delimiter: 'Carousel slide {0} of {1}',
                },
            },
            calendar: {
                moreEvents: '还有 {0} 项',
            },
            fileInput: {
                counter: '{0} 个文件',
                counterSize: '{0} 个文件（共 {1}）',
            },
            timePicker: {
                am: '上午',
                pm: '下午',
            },
            custom: {
                title: "EasyTour Student Platform",
                cancelBtn: '取消',
                okBtn: '确定',
                searchBtn: '查询',
                addBtn: '添加',
                deleteBtn: '删除',
                deleteBind: '取消绑定',
                enable: '启用',
                disable: '禁用',
                //表格
                dataLoading: '数据加载中...',
                dataNothing: '暂无数据',
                /*问询提示*/
                pleaseSelectDelete: '请选择要删除的数据',
                deleteNow: '确定要当前选中的所有数据吗?',
                deleteSelect: '确定要删除当前的数据吗?',
                cancelBind: '确定要取消绑定当前的用户吗?',
                /*表格列*/
                actions: '操作',
                creator: '创建人',
                createTime: '创建时间',
                editor: '修改人',
                updateTime: '修改时间',
                icon: "图标",
                image: "图片",
                preservation: "保存",
                pleaseSelectImageFile: "请选择图像文件",
                giveUpOperation: "放弃操作",
                pleaseEnery: "请输入",
                error: "错误",
                updateSuccess: "修改成功",
                tips: "提示",
                defaultContent: "默认内容",
                entryKeyWordSelect: "输入关键词回车查找",
                etBaseFramework: "易途基础框架",
                userSpaceAdd: "用户 添加",
                addSuccess: "添加成功",
                resetPassword: "重置密码",
                modifyPassword: "修改密码",
                passwordCheck: "管理员密码 验证",
                resetSuccess: "重置成功",

                adminCheckPassword: "安全起见我们需要确认您的管理员密码",
                modifyPasswordTip: "请输入新密码",
                originalPassword: "原始密码",
                detail: '详细',
                gender: '性别',
                phone: '手机号',
                date: '日期',
                yes: '是',
                no: '否',
                success: '成功',
                disabled: '已禁用',
                jurisdiction:'权限',
                data:'数据',
                userBindAdd: "关联用户",
                unUserBind: "取消关联",
                login: {
                    passwordLogin: '密码登录',
                    loginName: '邮箱/姓名/工号',
                    password: '请输入登录密码',
                    login: '登 录',
                    scanLogin: '扫码登录',
                    forgetPassword: '忘记密码',
                    forgetUsername: '忘记用户名',
                    register: '免费注册'
                },
                user: {
                    user: '用户',
                    work: '在职',
                    notWork: '离职',
                    pleaseSelect: '请选择',
                    username: '用户名',
                    password: "密码",
                    realname: '真实姓名',
                    phone: '手机',
                    email: '邮箱',
                    enableItems: '启用状态',
                    workItems: '在职状态',
                    lastLoginTime: '最后登录时间',
                    identity: '身份证号',
                    address: '地址',
                    dateEntry: '入职日期',
                    isWorking: '是否在职',
                    qqid: 'qq号',
                    weixin: '微信',
                    man: '男',
                    women: '女',
                    uploadAvatar: '上传头像',
                },
                menu: {
                    setUpState: "修改密码",
                    userInformation: "用户资料",
                    setUp: "设置",
                    logOUt: "退出",
                    menuPreview: "菜单预览",
                    menuName: "菜单名字",
                    routerAddress: "路由地址",
                    authorityCode: "权限编码",
                    updateMenu: "修改菜单",
                    deleteMenu: "删除菜单",
                    addPeer: "新增同级",
                    addSubset: "新增子集",
                    menuOperation: "菜单操作",
                    theCtNCAStPtPTAgain: "当前节点不能添加子集,请选择父级重试!",
                    canYCDTCMenu: "您确定要删除当前菜单吗?",
                    canYCDTCSubMenu: "您确定要删除当前菜单及子菜单吗?",
                },
                org: {
                    orgPreview: "组织预览",
                    orgOperation: "组织操作",
                    orgName: "组织名称",
                    orgCode: "组织编码",
                    orgOrder: "组织排序码",
                    updateOrg: "修改组织",
                    deleteOrg: "删除组织",
                    addPeer: "新增同级",
                    addSubset: "新增子集",
                    canYouSureDeleteOrg: "你确定删除当前组织吗",
                    orgOrderDesc: "排序码越小越靠前",
                    orgTree:"组织管理"
                },
                dict:{
                  dictId : "字典ID",
                  dataType : "数据类型",
                  dataCode : "数据编码",
                  dataValue : "数据名称/值",
                  dictOrder : "排序码",
                  dataDesc : "数据描述",
                  addChildBtn : "添加子集",
                  editBtn : "修改",
                  dictAddTile : "字典 添加"
                },
                operation: {
                    addOperation: '操作',
                    preview: '预览',
                    update: '修改操作',
                    delete: '删除操作',
                    add: "新增同级",
                    addSub: "新增子集",
                    name: "操作名称",
                    code: "权限编码",
                    deleteQuery: "确定要删除当前的操作吗?"
                },
                role:{
                    role:'角色',
                    name:'名称',
                    code:'编码',
                    pleaseEnterTheRoleName:'请输入角色名称',
                    pleaseEnterRoleCode:'请输入角色编码'
                },
                score:{
                    class:'班级',
                    name:'姓名',
                    preRank:'上次排名',
                    currRank:'本次排名',
                    preScore:'上次成绩',
                    currScore:'本次成绩',
                    studentName:'学生姓名',
                    appraise:'老师评价',
                    record:'跟踪记录',
                    update:'成绩 修改',
                    pleaseSelect:'选择班级'
                },
                student:{
                    name:'姓名',
                    gender:'性别',
                    idCard:'身份证号',
                    age:'年龄',
                    class:'班级',
                    firstClassName:'注册班级',
                    school:'学校',
                    source:'来源',
                    changeClassNum:'转班次数',
                    man: '男',
                    women: '女',
                    studentAdd:'学生 修改',
                    phone:'联系方式',
                    changeClass:'转班',
                    comeWithStudent:'同来学生',
                    update:'修改',
                    follow:'跟踪',
                    cancelFollow:'取消',
                    pleaseSelect:'选择学校',
                    changeClasses:'转班',
                    icePerson:'紧急联系人',
                    iceCall:'紧急联系人电话',
                    seatSearch:'座次查找',
                    supplementScore:'补录成绩',
                    supplementScorePop:'补录 成绩',
                    choiceClass:'选择班级',
                    choiceExam:'选择考试',
                    score:'分数',
                    setOuter:'设置进组',
                    outNum:'编号',
                    setSuccess:'设置成功',
                    add:'学生添加',
                },
                class:{
                    className:'班级名称',
                    room:'教室',
                    openTime:'开班时间',
                    teacher:'班主任',
                    relatedPersonnel:'关联人员',
                    rowSeats:'排座',
                    classAdd:'班级 修改',
                    classStudentUpdate:'班级人员 修改',
                    update:'修改',
                    updateList:'修改人员',
                    changeClassroom:'更换教室',
                    import:'从钉钉导入班级和学生',
                    ifRowSeats:'是否排座',
                    pleaseSelect:'选择',
                    graduation:'毕业',
                    graduated:'已毕业',
                    changeClasses:'从钉钉同步转班学生',
                },
                school:{
                    add:'添加',
                    update:'修改',
                    schoolUpdate:'学校 修改',
                    schoolAdd:'学校 添加',
                    schoolName:'学校名称',
                    userName:'负责人',
                    nickName:'学校简称',
                    currSchoolStudent:'该校学生',
                },
                exam:{
                    className:'班级名称',
                    add:'添加',
                    update:'修改',
                    examUpdate:'考试 修改',
                    import:'导入成绩',
                    export:'导出模板',
                    examName:'考试名称',
                    examTime:'考试时间',
                    type:'考试周期类型',
                    examType:'考试类型',
                    examAdd:'考试 添加',
                    pleaseSelect:'选择'
                },
                showStu:{
                    name:'姓名',
                    className:'隐藏前班级',
                    firstClassName:'注册班级',
                    schoolName:'学校',
                    source:'来源',
                    changeClassNum:'转班次数',
                    reason:'隐藏缘由',
                    etoakNo:'编号',
                    time:'入职时间',
                    showClassName:'班级',
                },
                showRecords:{
                    read:'已读',
                    notRead:'未读',
                    studentName:'学生姓名',
                    watchPic:'图片',
                    appraiseName:'评价人',
                    examName:'考试名称',
                    comment:'评价内容',
                    commentType:'类型',
                    appraiseTime:'评价时间',
                },
                outerList:{
                    appraise:"评价"
                },
                market:{
                    name:'请输入姓名',
                    addClue:'添加线索',
                    updateClue:'修改线索',
                    school:'选择学校',
                    profession:'请输入专业',
                    phone:'请输入手机号',
                    qq:'请输入qq号',
                    wechat:'请输入微信号',
                    source:'选择来源',
                    feeAlreadyFull:'学费已交齐',
                    others:'其他',
                    purposeTitle:'标记意向',
                    remarkTitle:'线索备注',
                    followTitle:'跟进记录',
                    feeTitle:'交费添加',
                    followWay:'跟进方式',
                    feeWay:'交费方式',
                    feeMoney:'交费金额',
                    feeContent:'交费内容',
                },
            },
        },
    },
}
